import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'
import { createPopper } from '@popperjs/core'
import { get } from '@rails/request.js'

export default class extends Controller {
  static targets = ['element']

  connect() {
    const noResultsLabel = this.elementTarget.dataset.noResults
    const create = this.elementTarget.dataset.create
    const isMultiple = this.elementTarget.multiple
    const remoteUrl = this.elementTarget.dataset.remoteUrl
    const preload = this.elementTarget.dataset.preload === 'true'

    const config = {
      valueField: 'id',
      searchField: ['text'],
      labelField: 'text',
      create: !!create,
      allowEmptyOption: true,
      preload: preload,
      load: this.#loadRemoteData(remoteUrl, preload),
      render: {
        no_results: (_data, _escape) => `<div class="no-results">${noResultsLabel}</div>`
      },
      // make the dropdown open on top or bottom based on the field position in the page
      // source: https://github.com/orchidjs/tom-select/discussions/163
      onInitialize: function () {
        this.popper = createPopper(this.control, this.dropdown)
        this.control.querySelector('input').autocomplete = 'one-time-code'
      },
      onDropdownOpen: function () {
        this.popper.update()
      }
    }

    if (isMultiple) {
      config.plugins = ['remove_button']
    }

    this.tomSelect = new TomSelect(this.elementTarget, config)
    // prevent auto-focus/open after turbo re-render when a value is already selected
    if (this.tomSelect.getValue()) {
      requestAnimationFrame(() => this.tomSelect.blur())
    }
  }

  disconnect() {
    this.tomSelect?.destroy()
    this.tomSelect = undefined
  }

  #loadRemoteData(remoteUrl, preload) {
    if (!remoteUrl) return

    return (query, callback) => {
      if (query.length < 3 && !preload) {
        return callback()
      }

      get(remoteUrl + `?q=${encodeURIComponent(query)}`)
        .then((response) => response.json)
        .then((data) => callback(data))
        .catch((_error) => callback())
    }
  }
}